import React from "react";
import { 
    Card, CardActions, CardContent, CardHeader, 
    IconButton, Grid, Typography, Divider 
} from "@material-ui/core";
import RefreshIcon from '@material-ui/icons/Refresh';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CloseIcon from '@material-ui/icons/Close';
import { createMarkup } from "../common";
import ModalImages from "../components/ModalImages";
import ReactCardFlip from 'react-card-flip';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    }
}));

export const FlashCard = props => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [flipped, setFlipped] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleFlipCard = (bool) => {
        setFlipped(bool);
    }

    const showQuestion = () => {
        return (
            <CardContent >                
                <div dangerouslySetInnerHTML={createMarkup(props.obj.text)}></div>
            </CardContent>
        )
    }

    const flipCard = () => {
        handleFlipCard(true);
    }

    const flipCardBack = () => {
        handleFlipCard(false);
    }

    return (
        <ReactCardFlip isFlipped={flipped} flipDirection="horizontal" infinite={true}>
            <Card 
                className="width100 margin-bottom-8"
            >
                <CardHeader 
                    title={`Question ${props.obj.number}`}
                    subheader={`SASP${props.obj.year}`}
                    action={
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                            onClick={() => flipCard()}
                            style={{backgroundColor: '#00567a', transform:"scale(0.67)"}}
                        >
                            <RefreshIcon className="headerIcons" />
                        </IconButton>
                    }

                    style={{
                        backgroundColor: "#f1f3f5"
                    }}
                />
                
                {showQuestion()}
                
                <CardActions
                    style={{ 
                        display:"flex",
                        flexDirection:"row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 16px",
                        backgroundColor: "#f1f3f5"
                    }}
                >
                    <IconButton
                        className="firstButton"
                        edge="start"
                        aria-label="firstIcon"
                        onClick={() => props.backFunc()}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <>
                        {typeof props.obj.imgs !== 'undefined' && props.obj.imgs.length > 0
                            ? (
                                <div className="padding-top-16">
                                    <ModalImages 
                                        qImages={props.obj.imgs}
                                        title={`SASP${props.obj.year} Question ${props.obj.number}`}
                                        style={{paddingTop:'16px !important'}}
                                    />
                                </div>
                            ) : null
                        }
                    </>

                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={() => props.nextFunc()}
                    >
                        <ArrowForwardIcon />
                    </IconButton>
                </CardActions>
            </Card>

            <Card 
                className="width100 margin-bottom-8"
            >
                <CardHeader 
                    title={`Question ${props.obj.number}`}
                    subheader={`SASP${props.obj.year}`}
                    action={
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                            onClick={() => flipCardBack()}
                            style={{backgroundColor: '#00567a', transform:"scale(0.67)"}}
                        >
                            
                            <CloseIcon className="headerIcons" />
                        </IconButton>
                    }

                    style={{
                        backgroundColor: "#f1f3f5"
                    }}
                />

                <CardContent>
                    <Grid item xs={12}>
                        <Typography 
                            className="DividerText anchor"
                        >
                            Answer
                        </Typography>
                        <Divider className="SASPDivider" />
                        <div><p><strong>{props.obj.answer.text}</strong></p></div>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography 
                            className="DividerText anchor"
                        >
                            Explanation
                        </Typography>
                        <Divider className="SASPDivider" />
                        <div dangerouslySetInnerHTML={createMarkup(props.obj.explanation)}></div>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography 
                            className="DividerText anchor"
                        >
                            References
                        </Typography>
                        <Divider className="SASPDivider" />
                        <div dangerouslySetInnerHTML={createMarkup(props.obj.reference)}></div>
                    </Grid>
                </CardContent>

                <CardActions
                    style={{
                        display:"flex",
                        flexDirection:"row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 16px",
                        backgroundColor: "#f1f3f5"
                    }}
                >
                    <IconButton
                        className="firstButton"
                        edge="start"
                        aria-label="firstIcon"
                        onClick={() => props.backFunc()}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <>
                        {typeof props.obj.imgs !== 'undefined' && props.obj.imgs.length > 0
                            ? (
                                <div className="padding-top-16">
                                    <ModalImages 
                                        qImages={props.obj.imgs}
                                        title={`SASP${props.obj.year} Question ${props.obj.number}`}
                                        style={{paddingTop:'16px !important'}}
                                    />
                                </div>
                            ) : null
                        }
                    </>

                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={() => props.nextFunc()}
                    >
                        <ArrowForwardIcon />
                    </IconButton>
                </CardActions>
            </Card>
        </ReactCardFlip>
    );
};